<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.countries') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="mappedData" :items-length="totalItems" :loading="loading"
                :search="search" item-value="id" @update:options="loadItems" @update:page="updatePage" height="60vh" :update:sortBy="updateSortBy"
                fixed-header :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)" class="shop-list-table"
                show-expand v-model:expanded="expanded">
                <template v-slot:expanded-row="{ columns, item }">
                    <tr class="expanded-row">
                        <td :colspan="columns.length">
                            <v-data-table :headers="subHeaders" :items="item.areas" density="compact">
                                <template v-slot:[`item.properties`]="{ value }">
                                    {{ value[`name${selectedLanguage.toUpperCase()}`] }}
                                </template>
                                <template v-slot:[`item.activeInFindeling`]="{ value }">
                                    <v-icon :color="value ? 'success' : 'error'"
                                        :icon="value ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'"></v-icon>
                                </template>
                                <template v-slot:[`item.fairlingTarget`]="{ value }">
                                    <v-icon :color="value ? 'success' : 'error'"
                                        :icon="value ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'"></v-icon>
                                </template>
                                <template v-slot:[`item.controls`]="props">
                                    <v-btn color="primary" variant="flat" size="32" class="mr-1"
                                        @click="() => editCity(props.item)">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:[`footer.prepend`]>
                                    <v-row>
                                        <v-col>
                                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                                            <v-btn color="primary" variant="flat" class="mr-1" rounded="xl" size="large"
                                                @click="() => createNewCity(item)">
                                                {{ $t('global.menu.backoffice.createCity') }}
                                            </v-btn>
                                        </v-col>
                                        <v-col>
                                            <!-- <CustomFilterMenu :title="'status'" :items="['disabled','published','pending','created']" v-model="filter" :multiple="true"></CustomFilterMenu> -->
                                            <!-- {{ filter }} -->
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-data-table>
                        </td>
                    </tr>
                </template>
                <template v-slot:top>
                    <v-row justify="space-between" class="mb-2" align="center">
                        <v-col cols="4">
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="true" :placeholder="$t('main.search.placeholder')"
                                variant="outlined" hide-details="true" density="compact" class="pb-2 py-0 bg-white"
                                height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn color="primary" variant="flat" class="mr-1" rounded="xl" size="large"
                                @click="createNewCountry">
                                {{ $t('global.menu.backoffice.createCountry') }}
                            </v-btn>
                            <!-- <CustomFilterMenu :title="'status'" :items="['disabled','published','pending','created']" v-model="filter" :multiple="true"></CustomFilterMenu> -->
                            <!-- {{ filter }} -->
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`item.code`]="props">
                    <span :class="{ 'fw-bold': expanded.includes(props.item.id) }">
                        {{ props.item.code }}
                    </span>
                </template>
                <template v-slot:[`item.nameTranslations`]="props">
                    <span :class="{ 'fw-bold': expanded.includes(props.item.id) }">
                        {{ props.item.nameTranslations[`name${selectedLanguage.toUpperCase()}`] }}
                    </span>
                </template>
                <template v-slot:[`item.activeIn`]="props">
                    <v-chip variant="flat" color="success" v-if="props.item.activeInFindeling" size="small"
                        class="mr-1">
                        Findeling
                    </v-chip>
                    <v-chip variant="flat" color="success" v-if="props.item.fairlingTarget" size="small">
                        Fairling
                    </v-chip>
                </template>
                <template v-slot:[`item.info`]="props">
                    <v-tooltip>
                        <template v-slot:activator="{ props }">
                            <v-icon v-bind="props">mdi-information-variant</v-icon>
                        </template>
                        <span>registered: {{ $formatDate(props.item.registered) }}</span><br>
                        <span>last Login: {{ $formatDate(props.item.lastLogin || null) }}</span>
                    </v-tooltip>
                </template>

                <template v-slot:[`item.controls`]="props">
                    <v-btn color="primary" variant="flat" size="32" class="mr-1" @click="() => editCountry(props.item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table-server>
        </v-row>

        <CreateCityDialog v-model="isCityDialogOpen" v-model:data="currentCity" :save="saveCity"></CreateCityDialog>
        <CreateCountryDialog v-model="isCountryDialogOpen" v-model:data="currentCountry" :save="saveCountry">
        </CreateCountryDialog>
        {{ currentCity }}
    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick, provide } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CreateCityDialog from './modals/CreateCityDialog.vue';
import CreateCountryDialog from './modals/CreateCountryDialog.vue';

export default {
    components: {
        CreateCityDialog,
        CreateCountryDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const isCityDialogOpen = ref(false);
        const isCountryDialogOpen = ref(false);
        const currentCity = ref(null);
        const currentCountry = ref(null);
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");

        const editCity = (item) => {
            fetchDistricts(item);
        }

        const updateSortBy = (newSort) => {
            proxy.sortBy = newSort;
        }

        const createNewCity = (country) => {
            currentCity.value = { countryId: country.id, properties: {}, location: {} }
            isCityDialogOpen.value = true;
        }

        const fetchDistricts = async (item) => {
            try {
                const response = await proxy.$axios.get(`/backoffice/cities/${item.id}/districts`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });

                if (response.data.status == "OK") {
                    item.districts = response.data.data;
                    currentCity.value = item;
                    isCityDialogOpen.value = true;
                }

            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        }

        provide("fetchDistricts",fetchDistricts)

        const saveCity = async () => {
            if (currentCity.value.id) {
                const copy = { ...(currentCity.value) };
                try {
                    const response = await proxy.$axios.put(`/backoffice/cities/${currentCity.value.id}`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        isCityDialogOpen.value = false;
                        console.log("proxy.countryPage",proxy.countryPage)
                        console.log("proxy.itemsPerPage",proxy.itemsPerPage)
                        proxy.loadItems({ page: proxy.countryPage, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy },true);
                    }
                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            } else {
                const { areas, ...copy } = currentCity.value;
                try {
                    const response = await proxy.$axios.post(`/backoffice/cities`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        isCityDialogOpen.value = false;
                        proxy.loadItems({ page: proxy.countryPage, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy },true);
                    }
                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
                 
            }
        }


        const createNewCountry = () => {
            currentCountry.value = { nameTranslations: {} }
            isCountryDialogOpen.value = true;
        }

        const editCountry = (item) => {
            currentCountry.value = item
            isCountryDialogOpen.value = true;
        }

        const saveCountry = async () => {
            if (currentCountry.value.id) {
                 
                const { areas, ...copy } = currentCountry.value;
                 
                try {
                    const response = await proxy.$axios.post(`/backoffice/country/update`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });
                    if (response.data.status == "OK") {
                        isCountryDialogOpen.value = false;
                        proxy.loadItems({ page: proxy.countryPage, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy })
                    }

                } catch (error) {
                    console.error("Error fetching search results:", error);
                }

            } else {
                if (typeof currentCountry.value.vouchersAvailable == 'undefined') {
                    currentCountry.value.vouchersAvailable = false;
                }
                currentCountry.value.fairlingTarget = false;
                currentCountry.value.activeInFindeling = false;
                 
                const { areas, ...copy } = currentCountry.value;
                try {
                    const response = await proxy.$axios.post(`/backoffice/country/new`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        isCountryDialogOpen.value = false;
                        proxy.loadItems({ page: proxy.countryPage, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy})
                    }

                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            }
        }


        const updatePage = (newPage) => {
            proxy.countryPage = newPage;
        }

        return {
            selectedLanguage,
            isCityDialogOpen,
            isCountryDialogOpen,
            currentCity,
            currentCountry,
            editCity,
            saveCity,
            editCountry,
            saveCountry,
            createNewCountry,
            createNewCity,
            updatePage,
            updateSortBy
        };
    },

    watch: {

    },

    data: () => ({
        itemsPerPage: 25,
        sortBy:[],
        countryPage: 1,
        expanded: [],
        pageOptions: [
            { value: 25, title: '25' },
            { value: 50, title: '50' },
            // { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: 'aktiv in', value: 'activeIn', align: 'start', maxWidth: "100px" },
            { title: 'Code', key: 'code', align: 'start', maxWidth: "200px" },
            { title: 'Name', value: 'nameTranslations', align: 'start' },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],

        subHeaders: [
            { title: 'Name', key: 'properties', align: 'start', maxWidth: "200px" },
            { title: 'ID', value: 'identifier', align: 'start', maxWidth: "100px" },
            { title: 'url', key: 'urlName', align: 'start', maxWidth: "200px" },
            { title: 'Findeling', key: 'activeInFindeling', align: 'start', maxWidth: "100px" },
            { title: 'Fairling', key: 'fairlingTarget', align: 'start', maxWidth: "100px" },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        search: '',
        serverItems: [],
        cityItems: [],
        loading: true,
        totalItems: 0,
    }),

    computed: {
        mappedData() {
            // Step 1: Convert largeObjects into a Map for quick lookup
            const objectMap = new Map((this.cityItems || []).map(obj => [obj.id, obj]));

            // Step 2: Map itemIds to their actual objects
            return (this.serverItems || []).map(group => ({
                ...group,
                areas: group.areaIds.map(id => objectMap.get(id)).filter(Boolean) // Remove undefined values
            }));
        },
        isRowExpanded() {
            return (id) => this.expanded.some(expandedItem => expandedItem.id === id);
        }
    },

    mounted() {
    },

    methods: {
        loadItems({ page, itemsPerPage, sortBy }, reloadCities = false) {
            this.loading = true
            console.log(this.search)
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");

            // FETCH CITIES
            if(this.cityItems.length == 0 || reloadCities){
                this.$axios.get(this.search.length >= 1 ? "/backoffice/shop/query" : "/backoffice/cities", {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-USER': username
                    },
                    params: {
                        ...(this.search.length >= 1 ? { name: this.search} : { page: page - 1})
                    }
                })
                    .then(this.citiesFetched)
                    .catch(error => {
                        console.error("Error fetching user data:", error);
                        // You can handle specific error codes here, for example, a 401 Unauthorized
                        if (error.response && error.response.status === 401 || error.response.status === 403) {
                            // Handle token expiration or unauthorized error
                            console.log("Session expired or unauthorized. Please log in again.");
                            // Optionally log the user out or redirect to login page
                        }
                    });
            }

            // FETCH COUNTRIES
            this.$axios.get(this.search.length >= 1 ? "/backoffice/shop/query" : "/backoffice/country/v2/all", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
                params: {
                    ...(sortBy != null? { sortColumn: sortBy[0]?.key, sortDirection: sortBy[0]?.order.toUpperCase()} : {}),
                    ...(this.search.length >= 1 ? { name: this.search, resultsPerPage: itemsPerPage, page: page - 1 } : { page: page - 1, resultsPerPage: itemsPerPage })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });


        },
        itemsFetched(response) {
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        },
        citiesFetched(response) {
            this.cityItems = response.data.data;
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}

.expanded-row {
    border-bottom: medium solid rgba(var(--v-border-color), var(--v-border-opacity));
    border-top: medium solid rgba(var(--v-border-color), var(--v-border-opacity));
}
</style>

<style></style>

<style></style>